import { render } from "./PostTopicBtn.vue?vue&type=template&id=18dbd6de&scoped=true"
import script from "./PostTopicBtn.vue?vue&type=script&lang=ts"
export * from "./PostTopicBtn.vue?vue&type=script&lang=ts"

import "./PostTopicBtn.vue?vue&type=style&index=0&id=18dbd6de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18dbd6de"

export default script